import { render, staticRenderFns } from "./PlanDialog.vue?vue&type=template&id=228b76ef&scoped=true"
import script from "./PlanDialog.vue?vue&type=script&lang=js"
export * from "./PlanDialog.vue?vue&type=script&lang=js"
import style0 from "./PlanDialog.vue?vue&type=style&index=0&id=228b76ef&prod&lang=scss&scoped=true"
import style1 from "./PlanDialog.vue?vue&type=style&index=1&id=228b76ef&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "228b76ef",
  null
  
)

export default component.exports